const cacheActions = (store) => {
    store.cache = new Map();
    store.cache.dispatch = (...args) => {
        const type = args[0];
        if (!store.cache.has[type]) {
            store.cache.set(type, store.dispatch(...args));
        }
        return store.cache.get(type);
    };
};

export default cacheActions;



// WEBPACK FOOTER //
// ./src/assets/plugin/cacheActions.js